import { render, staticRenderFns } from "./FD33.vue?vue&type=template&id=64e5ddf7&"
import script from "./FD33.vue?vue&type=script&lang=js&"
export * from "./FD33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports